import React, { useState } from 'react';
import type { HTMLAttributes } from 'react';
import type { AllIconType, ElementColorType } from '../../../util/types';
import type { StudentType } from '../../types';
import { getPolishedColors } from '../../../util/styled';
import { getIconComponent } from '../../../util/reactFunc';
import { Alert, Slide } from '../../../components';
import { InfoButton, StudentButton } from '../../../global';
import styled from 'styled-components';
import { useI18n } from '@whizz/react-i18n';

type Ref = HTMLDListElement;
type HTMLProps = HTMLAttributes<Ref>;
interface ListItemProps extends HTMLProps {
  students: StudentType[];
  color: ElementColorType;
  description: string;
  moreInfo: string;
  children: React.ReactNode;
  buttonText?: string;
  icon?: AllIconType | false;
}

const StudentsContainerStyled = styled('div')<{ $color: ElementColorType; }>`
  border-radius: ${(props) => props.theme.radius.default};
  border: 2px solid ${(props) => getPolishedColors(props).main.color}};
`;

const ListItem = ({ students, color, description, moreInfo, children, buttonText, icon = 'Lens' }: ListItemProps): JSX.Element => {

  const { translate } = useI18n();
  const [ showInfo, setShowInfo ] = useState(false);
  const [ showContent, setShowContent ] = useState(false);

  return (
    <div>
      <div className={'lg:flex items-center justify-between'}>
        <div className={'flex flex-nowrap items-center py-2'}>
          {icon ? <div className={'mr-sm'}>{getIconComponent(icon, 14, 'negative')}</div> : null }
          <b>{description}</b>
          <InfoButton onClick={() => setShowInfo((prev) => !prev)} />
        </div>
        <div className={'flex items-center justify-end'}>
          <StudentButton
            disabled={students.length <= 0}
            color={color}
            text={buttonText ?? translate('components.BUTTONS.STUDENTS.HELP_X', { count: students.length })}
            toggled={showContent}
            onClick={() => setShowContent(!showContent)}
          />
        </div>
      </div>
      <Alert disableIcon show={showInfo} className={'my-md'}>
        {moreInfo}
      </Alert>
      <Slide when={null != children && showContent}>
        <div className={'bg-white'}>
          <StudentsContainerStyled
            $color={color}
            className={'container mt-md'}
          >
            {children ?? ''}
          </StudentsContainerStyled>
        </div>
      </Slide>
    </div>
  );
};

ListItem.displayName = 'ListItem';

export default ListItem;
